module.exports = __webpack_public_path__ + "assets/img/dc9f5f388e438c5cfc9531892c02b35e.png";